import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Chatbot = _resolveComponent("Chatbot");
  return _openBlock(), _createElementBlock("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.components.dataLayer, (cmp, id) => {
    return _openBlock(), _createBlock(_resolveDynamicComponent(cmp['@type'] in _ctx.$options.components ? cmp['@type'] : 'CoreComponent'), {
      key: id,
      ref_for: true,
      ref: id
    });
  }), 128)), _createVNode(_component_Chatbot)]);
}